// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "main.module." + "007bfc5348890299b08f" + ".js";
};